import { catalog } from "../i18n.js";

/** A bot's routines (components/Routines.tsx). The schedule's own description ("every day at 09:00") comes from the host. */
export const ROUTINES = catalog(
  {
    title: "Routines",
    intro: (bot: string, zone: string) => `Standing orders ${bot} runs on a schedule, whether or not you are here. Schedules are read in ${zone}.`,
    useBrowserZone: (zone: string) => `Use this browser’s zone (${zone})`,
    close: "Close",
    loading: "Loading…",
    empty: (bot: string) => `No routines yet. ${bot} can make its own, or add one below.`,
    next: (at: string) => `next ${at}`,
    paused: "paused",
    running: "running",
    last: (status: string) => `last ${status}`,
    open: (name: string) => `Edit ${name}`,
    runNow: "Run now",
    pause: "Pause",
    resume: "Resume",
    edit: "Edit",
    delete: "Delete",
    deleteTitle: (routine: string) => `Delete the routine "${routine}"?`,
    deleteMessage: "It stops running. This cannot be undone.",
    newRoutine: "New routine",
    name: "Name",
    namePlaceholder: "Morning news",
    schedule: "Schedule",
    scheduleHint: "five cron fields, or @daily / @every 30m (at most every 30 minutes); prefix CRON_TZ=Europe/Berlin to pin a zone",
    instruction: "Instruction",
    instructionHint: "what to do each time; say when to stay quiet, or it will report every run",
    instructionPlaceholder: "Check the release board and tell me only if something moved.",
    create: "Create",
    save: "Save",
    cancel: "Cancel",
  },
  {
    title: "Rutinitas",
    intro: (bot: string, zone: string) => `Tugas tetap yang dijalankan ${bot} sesuai jadwal, ada kamu atau tidak. Jadwal dibaca dalam zona ${zone}.`,
    useBrowserZone: (zone: string) => `Pakai zona browser ini (${zone})`,
    close: "Tutup",
    loading: "Memuat…",
    empty: (bot: string) => `Belum ada rutinitas. ${bot} bisa membuatnya sendiri, atau tambahkan di bawah.`,
    next: (at: string) => `berikutnya ${at}`,
    paused: "dijeda",
    running: "berjalan",
    last: (status: string) => (status === "ok" ? "terakhir berhasil" : status === "error" ? "terakhir gagal" : `terakhir ${status}`),
    open: (name: string) => `Ubah ${name}`,
    runNow: "Jalankan sekarang",
    pause: "Jeda",
    resume: "Lanjutkan",
    edit: "Ubah",
    delete: "Hapus",
    deleteTitle: (routine: string) => `Hapus rutinitas "${routine}"?`,
    deleteMessage: "Rutinitas ini berhenti berjalan. Tindakan ini tidak bisa dibatalkan.",
    newRoutine: "Rutinitas baru",
    name: "Nama",
    namePlaceholder: "Berita pagi",
    schedule: "Jadwal",
    scheduleHint: "lima kolom cron, atau @daily / @every 30m (paling sering tiap 30 menit); awali dengan CRON_TZ=Europe/Berlin untuk mengunci zona",
    instruction: "Instruksi",
    instructionHint: "apa yang dikerjakan tiap kali; bilang kapan harus diam, kalau tidak ia melapor setiap kali jalan",
    instructionPlaceholder: "Cek papan rilis dan kabari saya hanya kalau ada yang berubah.",
    create: "Buat",
    save: "Simpan",
    cancel: "Batal",
  },
);
